import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { translateFr as tfr } from "@/i18n";

export default function TrialBanner() {
  const [s, setS] = useState(null);

  useEffect(() => {
    let live = true;
    api.get("/billing/status")
      .then((r) => { if (live) setS(r.data); })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  if (!s) return null;
  // Show only if trial < 7 days OR expired/past_due
  const showTrial = s.state === "trialing" && s.trial_days_left <= 7;
  const showExpired = s.state === "expired";
  const showPastDue = s.state === "past_due";
  if (!showTrial && !showExpired && !showPastDue) return null;

  let bg, text, icon, label;
  if (showExpired) {
    bg = "bg-red-500/10 border-red-500/20";
    text = "text-red-300";
    icon = <AlertTriangle className="h-3.5 w-3.5" />;
    label = tfr("Votre essai est expiré — abonnez-vous pour réactiver l'écriture");
  } else if (showPastDue) {
    bg = "bg-amber-500/10 border-amber-500/20";
    text = "text-amber-300";
    icon = <AlertTriangle className="h-3.5 w-3.5" />;
    label = tfr("Paiement en retard — mettez à jour votre carte");
  } else {
    bg = "bg-blue-500/10 border-blue-500/20";
    text = "text-blue-300";
    icon = <Sparkles className="h-3.5 w-3.5" />;
    label = `${s.trial_days_left} ${s.trial_days_left > 1 ? tfr("jours d'essai restants") : tfr("jour d'essai restant")}`;
  }

  return (
    <div
      className={`border-y ${bg} ${text} text-xs`}
      data-testid="trial-banner"
    >
      <div className="container mx-auto px-4 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          {icon}
          <span>{label}</span>
        </div>
        <Link
          to="/pricing"
          className="font-medium underline-offset-2 hover:underline"
          data-testid="trial-banner-cta"
        >
          {showTrial ? "Activer Pro" : "Voir l'offre"} →
        </Link>
      </div>
    </div>
  );
}
